import React from 'react'

const MainTitle = () => {
  return (
    <div>
      <h1 className='main-title'>ShowLab | @mahimvyas</h1>
    </div>
  )
}

export default MainTitle
